import robuxModule from "../robuxModule";

function robuxSubscriptionUpsellPackage(premiumService, premiumConstants, $filter) {
    "ngInject";

    return {
        restrict: "A",
        scope: {
            'product': "=",
            'isUpsell': "="
        },
        templateUrl: premiumConstants.templates.robuxSubscriptionUpsellPackage,
        link: function (scope, element, param) {
            scope.layout = {
                isPremiumUser: false
            };
            scope.upsellPackage = null;

            scope.$watch(
                function (scope) {
                    return scope.$parent.robuxPageData.upsellPackage;
                },
                function (newVal, oldVal, scope) {
                    if (scope.isUpsell && newVal) {
                        scope.upsellPackage = newVal;
                        scope.upsellPackage.isRecurring = scope.upsellPackage.subscriptionTypeName.toLowerCase().indexOf(premiumConstants.premiumFeatureType.month) < 0;
                    }
                });
            
            scope.$watch(
                function (scope) {
                    return scope.$parent.robuxPageData.userPlan;
                },
                function (newVal, oldVal, scope) {
                    if (newVal) {
                        scope.layout.isPremiumUser = newVal.hasOwnProperty('subscriptionTypeName');
                    }
                });

            scope.getPurchaseUrl = function (product) {
                return premiumService.getPurchaseUrl(product, premiumConstants.pageContext.robux);
            }
        }
    };
}

robuxModule
    .directive("robuxSubscriptionUpsellPackage", robuxSubscriptionUpsellPackage);

export default robuxModule;